export default __webpack_public_path__ + "static/media/chinese-market.da215703.jpg";